function convertArrayOfObjectsToCSV(data) {
    const csv = [];
    const headers = Object.keys(data[0]);

    csv.push(headers.join(','));
    for (const row of data) {
        const values = headers.map((header) => {
            const escaped = ('' + row[header]).replace(/"/g, '\\"');
            return `"${escaped}"`;
        });
        csv.push(values.join(','));
    }

    return csv.join('\n');
}

const formatAddressForCampaignSupporters = (data) => {
    let address = '';
    if (data.address_1) address += `${data.address_1}, `;
    if (data.city_state) address += `${data.city_state}, `;
    if (data.state) address += `${data.state} `;
    if (data.zip_code) address += `${data.zip_code}`;
    delete data?.address_1;
    delete data?.city_state;
    delete data?.state;
    delete data?.zip_code;
    data.address = address;
};

export function downloadCSV(data, filename) {
    // if (filename.includes('Campaign Supporters')) {
    //   data.map((d) => formatAddressForCampaignSupporters(d));
    // }
    const csv = convertArrayOfObjectsToCSV(data);
    const blob = new Blob(['\ufeff' + csv], {
        type: 'text/csv;charset=utf-8;',
    });

    if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
    } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename + '.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
